// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","443":"about"}[chunkId] || chunkId) + "." + {"177":"151107ef","443":"fedc1b50","502":"e0f6ef19","851":"263d0a45","885":"4713b943"}[chunkId] + ".js";
};